import React, { Component } from 'react';
//import ReactTable from "react-table"
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
//import { DialogComponent } from '@syncfusion/ej2-react-popups';
import DataTable from 'react-data-table-component';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';


class AddHealthSystemAdmin extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteAdminApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        this.state = {
            paginationValue: 10,
            language: null,
            // data: [
            //     {
            //         id: '',
            //         answer: '',
            //         originalQuestionId: '',
            //         // categoryTags: '',
            //         autoTranslate: '',
            //         alias: '',
            //     }
            // ],
            data : [],
            pageNum: null,
            faqid: '',
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            editedName: "",
            editedEmailId: "",
            editedPhoneNumber: "",
            dummyUUID: "00000000-0000-0000-0000-000000000000",
            searchTerm: "",
            noMatchingData: false,
            isLoading : true,
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    }

    NotifyFailToLoad() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addRow = (data) => {
        var ansController = this;
        ansController.state.paginationValue = ansController.state.paginationValue + 5;
        if (ansController.state.pageNum != 0) {
            ansController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            answer: '',
            autoTranslate: '',
        });
        this.setState({
            data: this.state.data,
            disabled: true,
            noMatchingData: false
        })
    }

    addAdminApi = (row, e) => {

        var thisController = this;

        var adminName = document.getElementById("adminName" + row.index).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + row.index).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + row.index).innerText.trim();
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
        );
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);

        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.notifyMsgFieldEmpty();

        }
        else if (!namePattern.test(adminName)) {
            thisController.notifyImproperName();
        }
        else if (!pattern.test(adminEmailId)) {
            thisController.notifyImproperEmailId();
        }

        else if (!contactNumberPattern.test(adminContactNumber)) {

            thisController.notifyImproperContactNumber();
        }

        else {
            $.ajax({
                url: "/my-jeeva-api/provider-admin",

                method: 'POST',
                data:
                {
                    role: "HEALTHSYSTEM_ADMIN",
                    userName: document.getElementById("adminName" + row.index).innerText.trim(),
                    userEmailId: document.getElementById("adminEmailId" + row.index).innerText.trim(),
                    userPhoneNumber: document.getElementById("adminContactNumber" + row.index).innerText.trim(),
                    healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },

                success: function (res) {
                    if (res.success === true) {
                        if (res.result == "done") {
                            thisController.NotifyAdd();
                            thisController.state.disabled = false;
                            thisController.fetchHeathSystemAdminApi();
                        } else {
                            thisController.notifyExistingUser(res.result);
                            thisController.state.disabled = false;
                        }
                        // addAnswerController.setState({ hideAddDialog: true });

                    } else {
                        if (res.result != "") {
                            thisController.notifyFailedToAdd(res.result);
                            thisController.state.disabled = false;
                        }
                        else {
                            // thisController.NotifyFailToLoad();
                            thisController.state.disabled = false;
                        }
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }

    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no healthsystem admin present. </p>
        </div>
    );

    NotifyAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Health System Admin detail has been added successfully</b>, {
            position: "top-center",

        });

    }
    notifyExistingUser() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
            This user already exists</b>, {
            position: "top-center",

        });

    }
    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }
    notifyFailedToAdd(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    makeCelleditable(row, e) {
        this.markAsBeingEdited(row.id);
        this.state.editedName = row.userName;
        this.state.editedEmailId = row.userEmailId;
        this.state.editedPhoneNumber = row.userPhoneNumber;
        this.setState(this.state);
    }
    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    handleNameChange = (e, props) => {
        this.state.editedName = e.currentTarget.textContent;
        this.setState(this.state);
    }
    handleEmailIdChange = (e, props) => {
        this.state.editedEmailId = e.currentTarget.textContent;
        this.setState(this.state);
    }
    handlePhoneNumberChange = (e, props) => {
        this.state.editedPhoneNumber = e.currentTarget.textContent;
        this.setState(this.state);
    }

    updateApi(row, e) {
        var adminName = document.getElementById("adminName" + row.index).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + row.index).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + row.index).innerText.trim();
        var thisController = this
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
        );
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.notifyMsgFieldEmpty();
        }
        else if (!namePattern.test(adminName)) {
            thisController.notifyImproperName();
        }
        else if (!pattern.test(adminEmailId)) {
            thisController.notifyImproperEmailId();
        }

        else if (!contactNumberPattern.test(adminContactNumber)) {

            thisController.notifyImproperContactNumber();
        }

        else {
            var saveData = {
                id: row.id,
                healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
                userRole: "HEALTHSYSTEM_ADMIN",
                // userEmailId: document.getElementById("adminEmailId" + row.index).innerText.trim(),
                // userName: document.getElementById("adminName" + row.index).innerText.trim(),
                // userPhoneNumber: document.getElementById("adminContactNumber" + row.index).innerText.trim(),
                userName: thisController.state.editedName.trim(),
                userEmailId: thisController.state.editedEmailId.trim(),
                userPhoneNumber: thisController.state.editedPhoneNumber.trim(),
                procedureId: this.state.dummyUUID,
                hospitalId: this.state.dummyUUID,
                serviceLineId: this.state.dummyUUID,

            }

            $.ajax({
                url: "/my-jeeva-api/provider",

                method: 'PATCH',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },

                success: function (res) {
                    if (res.success === true) {
                        thisController.state.editedId = "-1";
                        thisController.notifyUpdated();
                        thisController.state.disabled = false;
                        thisController.fetchHeathSystemAdminApi();
                    } else {
                        if (res.result != "") {
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.disabled = false;
                        }
                        else {
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.disabled = false;
                        }
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }
    }

    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Health System Admin details has been updated successfully</b>, {
            position: "top-center",

        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    validateCells(answer) {
        if ((answer == "")) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    notifyImproperEmailId() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid email id</b>, {
            position: "top-center"
        });

    }
    notifyImproperContactNumber() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid contact number</b>, {
            position: "top-center"
        });
    }
    deleteAdminApi = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            var deleteData = {
                id: props.id,
                emailId: props.userEmailId,
                userRole: 'HEALTHSYSTEM_ADMIN',
                healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
            }
            $.ajax({
                url: "/my-jeeva-api/delete-user",

                method: 'POST',
                data: JSON.stringify(deleteData),
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {
                    if (res.success === true) {
                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteRowViewController.splice(props.id, 1);
                        deleteConstructorVariables.notifyMsgDeleteSuccess();
                        deleteConstructorVariables.fetchHeathSystemAdminApi();

                    } else {
                        if (res.result != "") {
                            deleteConstructorVariables.notifyFailToDelete(res.result);
                        }
                        // deleteConstructorVariables.NotifyFailToLoad();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            });
        }
    }

    notifyMsgDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Health System Admin detail has been deleted successfully</b>, {
            position: "top-center"
        });
    }

    notifyFailToDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    refreshData = (id) => {
        this.setState({
            editedId: id,
            disabled: false,
            isLoading : true,
            searchTerm : "",
            noMatchingData : false,
            data: []
        });
        this.fetchHeathSystemAdminApi();
    };


    fetchHeathSystemAdminApi = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/provider",

            method: 'GET',
            data: {
                healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
                role: 'HEALTHSYSTEM_ADMIN'
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    thisController.setState({
                        data: res.result,
                        disabled: false,
                        noMatchingData: false,
                        isLoading : false,
                    })
                }
                else {
                    thisController.setState({
                        isLoading : false,
                        noMatchingData: false,
                    })
                    // thisController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/my-jeeva/login";
                }
            }
        });
    }


    componentDidMount() {

        setTimeout(() => {
            this.fetchHeathSystemAdminApi();
        }, 300);



    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }
    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.userName} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteAdminApi(props)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        const a = rowA[field] ? rowA[field].toLowerCase() : '';
        const b = rowB[field] ? rowB[field].toLowerCase() : '';

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.setState(thisController.state);

        var healthSystemId;

        healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
            "healthSystemId"
        ];
        var role = JSON.parse(localStorage.getItem("user_details"))[
            "userRole"
        ];

        $.ajax({
            url: "/my-jeeva-api/search-admins-data",
            method: "GET",
            data: {
                healthSystemId: healthSystemId,
                searchTerm: thisController.state.searchTerm,
                role: role
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.data = [];
                        thisController.state.noMatchingData = false;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                        thisController.state.data = res.result;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {

            },
        });

    };

    render() {
        const { data } = this.state
        const columns = [

            {
                name: <b style={{ fontSize: '16px' }}>Name</b>,
                sortFunction: this.caseInsensitiveSort('userName'),
                sortable: true,
                selector: row => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{
                            height: '5vh',
                            background: 'white', resize: 'none', borderBottom: 'none', border: (row.id == this.state.editedId || row.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (row.id == this.state.editedId || row.id == "") ? '2px' : 'none', paddingLeft: '2px'
                        }}
                        onInput={(e) => { this.handleNameChange(e, row) }}
                        id={"adminName" + row.index}
                        rows="1"
                        contentEditable={!((row.id == "") ? false :
                            row.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{row.userName}

                    </div>)
            },
            {
                name: <b style={{ fontSize: '16px' }}>Email ID</b>,
                sortFunction: this.caseInsensitiveSort('userEmailId'),
                sortable: true,
                selector: row => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', background: 'white', resize: 'none', borderBottom: 'none', border: (row.id == this.state.editedId || row.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (row.id == this.state.editedId || row.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"adminEmailId" + row.index}
                        onInput={(e) => { this.handleEmailIdChange(e, row) }}
                        rows="1"
                        contentEditable={!((row.id == "") ? false :
                            row.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{row.userEmailId}

                    </div>)
            },
            {
                name: <b style={{ fontSize: '16px' }}>Contact Number</b>,
                sortFunction: this.caseInsensitiveSort('userPhoneNumber'),
                sortable: true,
                selector: row => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', background: 'white', resize: 'none', borderBottom: 'none', border: (row.id == this.state.editedId || row.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (row.id == this.state.editedId || row.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"adminContactNumber" + row.index}
                        onInput={(e) => { this.handlePhoneNumberChange(e, row) }}
                        rows="1"
                        contentEditable={!((row.id == "") ? false :
                            row.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{row.userPhoneNumber}

                    </div>)
            },

            {
                name: <b style={{ fontSize: '16px' }}>Action</b>,
                width: 100,
                selector: row => (
                    <div id="action">

                        <button
                            //className="btn2 table-action-button "
                            style={{
                                backgroundColor: "#ffffff", border: "none",
                                // marginTop: '-13px'
                            }}>
                            <img className="img-responsive"
                                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                // title={(row.id == "") ||
                                //     (this.state.data[row.index].id == this.state.editedId) ? 'Save' : 'Edit'}

                                src={(row.id == "") ?
                                    this.saveImageSrc : ((row.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (row.id == "") ?
                                        this.addAdminApi(row, e) :
                                        (row.id == this.state.editedId) ?
                                            this.updateApi(row, e) :
                                            this.makeCelleditable(row, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (row.id) === '' ?
                                    this.fetchHeathSystemAdminApi() : this.openDeletePopUp(row)
                                    //     this.setState({
                                    //         hideDeletePopup: true, deletePropIndex: row.index,
                                    //         propsId: row.id
                                    //     })
                                }
                            />
                        </button>

                    </div>
                ),

            },

        ]
        return (
            <div id='addHealthSystemAdminTab' style={{ background: "#F9F9FB" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />

                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            {/* <div className="col-sm-4" style={{ marginTop: '16px' }}  >

                            </div> */}
                            <div >
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
                                    Health System Admin</h6>
                                {/* <h6 className="taglineTxt" style={{ textAlign: 'center' }}>FAQ Answers</h6> */}
                            </div>
                            <div style={{ marginLeft: "55vw", marginTop: "1vh" }}>
                                <input
                                    type="text"
                                    style={{
                                        width: "12vw",
                                        border: "2px solid #777676",
                                        borderRadius: "10px",
                                        padding: "10px",
                                        height: "0.7vw"
                                    }}
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearch}
                                    placeholder="Search ..."
                                />
                            </div>
                            {/* Add button */}
                            <div Align='right' style={{ marginLeft: "3vw"}}>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData}
                                    title="Refresh"
                                    className="btn action-button">
                                    {/* style={{ width: '45px',margin: '5px' }}>Refresh */}
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* left Menu start here*/}
                    {/* Content Header (Page header) */}
                    {/* /.content-header */}
                    {/* Custom Tabs */}
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                   {!this.state.noMatchingData &&
                                    <div className="card">
                                       {this.state.isLoading && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                          <p>Loading ...</p>
                                        </div>
                                      )}
                                      {!this.state.isLoading && this.state.data.length === 0 &&  (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                          <p>There are no healthsystem admin present.</p>
                                        </div>
                                      )}
                                      {(!this.state.isLoading && this.state.data.length > 0 ) && (
                                            <DataTable
                                                data={this.state.data}
                                                defaultSortFieldId
                                                columns={columns}
                                                pagination={this.state.paginationValue}
                                                defaultSortFieldName
                                                fixedHeaderScrollHeight="400px"
                                                noDataComponent={<this.CustomNoDataComponent />}
                                            />
                                        )}
                                        {/* <DataTable
                                            // data={data}
                                            // columns={columns}
                                            // defaultPageSize={10}
                                            // pageSizeOptions={[5, 10, 15]}
                                            // onPageChange={this.onPageChange}
                                            // page={this.state.pageNum}
                                            // columns={columns}
                                            data={this.state.data}
                                            defaultSortFieldId
                                            columns={columns}
                                            pagination={this.state.paginationValue}
                                            defaultSortFieldName
                                            fixedHeaderScrollHeight="400px"
                                            noDataComponent={<this.CustomNoDataComponent />}
                                        /> */}
                                    </div>}
                                    <ToastContainer className="Toast-at-center" />
                                    <div className='card'>
                                        {this.state.noMatchingData &&
                                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                                <p>No matching options found ...</p>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default AddHealthSystemAdmin;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/AddHealthSystemAdmin.js